import { AmplitudeEventProperty, logAmplitudeEvent } from 'chairisher/util/analytics';

/**
 * Tracks when the SMS modal is loaded
 */
export function trackSmsModalShow() {
    logAmplitudeEvent('sms modal - show', { [AmplitudeEventProperty.IS_GATED]: false });
}

/**
 * Tracks when the SMS modal is closed
 */
export function trackSmsModalClose() {
    logAmplitudeEvent('sms modal - close');
}

/**
 * Tracks when the SMS collection form input receives focus
 */
export function trackCollectionFormInputFocus() {
    logAmplitudeEvent('sms collection form - input received focus');
}

/**
 * Tracks when the SMS collection form is submitted
 */
export function trackFormSubmitted() {
    logAmplitudeEvent('sms collection form - form submitted');
}

/**
 * Tracks when the SMS collection form submission is successful
 */
export function trackFormSuccess() {
    logAmplitudeEvent('sms collection form - form submission successful');
}

/**
 * Tracks when the SMS collection form submission fails
 */
export function trackFormFailure() {
    logAmplitudeEvent('sms collection form - form submission failure');
}
